<template lang="pug">

    form.ui.segment.z-dz
        .ui.inverted.dimmer(v-bind:class='{ active: uploadIsActive }')
            .ui.primary.elastic.loader Datei wird hochgeladen
        p Hochzuladende Datei hierher ziehen


</template>

<script>
    import Dropzone  from 'dropzone'

    export default {

        data() {
            return {
                uploadIsActive: false,
            }
        },

        mounted() {
            // Auto-Discover-Feature von Dropzone deaktivieren
            Dropzone.autoDiscover = false

            // Dropzone-Instanz erstellen
            const dropzone = new Dropzone(this.$el, {
                clickable: this.$el.querySelector('p'),
                createImageThumbnails: false,
                headers: { Authorization: this.$auth.token },
                maxFilesize: 1024 * 1024 * 1024,
                previewsContainer: false,
                autoQueue: false,
                url: '/uploads',
            })

            this.progressBar = jQuery(this.$refs.progressBar).progress({
                percent: 0
            })

            dropzone.on('addedfile', async file => {
                try {
                    // Uploadzugriff erstellen
                    const uploadModel = await this.$store.dispatch('uploads/create')

                    // Upload-URL erstellen
                    const url = `/uploads/${uploadModel.id}?access-key=${uploadModel.accessKey}`

                    // Payload erstellen
                    const data = new FormData()
                    data.append('file', file)

                    // Loading-Indicatore anzeigen
                    this.uploadIsActive = true

                    // Upload durchfuehren
                    const response = await fetch(url, {
                        method: 'POST',
                        body: data
                    })

                    // File-ID holen und `uploading`-Event auslösen
                    const { id } = await response.json()

                    // File-model laden (silent, damit der globale Ladeindikator nicht flackert)
                    const fileModel = await this.$store.dispatch('files/loadOne', { id, silent: true })

                    // `uploaded`-Event ausloesen
                    this.$emit('uploaded', { fileModel })

                    // Loading-Indicatore verbergen
                    this.uploadIsActive = false
                } catch (e) {
                    // Sicherstellen dass Spinner nie hängen bleibt
                    this.uploadIsActive = false
                    this.$growl.fatal('Upload fehlgeschlagen', e)
                }
            })
        },

    }

</script>


<!--suppress CssUnusedSymbol -->
<style scoped>
    .z-dz {
        padding: 0 !important;
        margin-top: 24px;
        font-size: 1.28571429rem !important;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        border-radius: 6px;
        border: 2px dashed #dfe0e1;
    }

    .z-dz p {
        line-height: 10rem;
    }

    .z-dz.dz-drag-hover {
        color: rgba(0, 0, 0, .3) !important;
    }

    .z-dz:hover {
        background: #dedede !important;
        color: #000 !important;
    }

    .z-dz:active {
        background-color: #babbbc !important;
    }

    .dz-preview {
        display: none !important;
    }

</style>
